import { z } from 'zod'
import { LearningStatus } from '@/core/domain/resources/enums/LearningStatus'
import {
  LearningModuleListSchema,
  LearningModuleSchema
} from '@/core/infrastructure/schemas/learning/module/LearningModuleSchema'
import { ReferentialDomainSchema } from '@/core/infrastructure/schemas/referential/domain/ReferentialDomainSchema.ts'

// Schema de base pour un cours d'apprentissage
export const LearningCourseSchema = z.object({
  id: z.number(),
  title: z.string(),
  status: z.nativeEnum(LearningStatus.Values),
  order: z.number(),
  name: z.string(),
  nameSlug: z.string(),
  domain: ReferentialDomainSchema,
  learningModules: z.array(LearningModuleSchema),
  createdBy: z.string().optional(),
  createdAt: z.string().datetime().optional(),
  modifiedBy: z.string().optional(),
  modifiedAt: z.string().datetime().optional()
})

// Liste de cours
export const LearningCourseListSchema = z.array(LearningCourseSchema)

// Schema pour envoi a l'API
export const LearningCourseInputSchema = LearningCourseSchema.omit({
  nameSlug: true,
  createdBy: true,
  createdAt: true,
  modifiedBy: true,
  modifiedAt: true
}).extend({
  id: z.number().optional(),
  learningModules: LearningModuleListSchema.optional()
})

export type LearningCourseEntity = z.infer<typeof LearningCourseSchema>
export type LearningCourseListEntity = z.infer<typeof LearningCourseListSchema>
